import { useAuth } from "@/providers/AuthProvider";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useNavigate } from "react-router";
import { Button } from "./ui/button";
import { Users2Icon } from "lucide-react";
import { GearIcon } from "@radix-ui/react-icons";
import { useState } from "react";

export function TeamSelector() {
  const { teams, activeTeam, switchTeam } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  if (!teams || teams.length === 0) {
    return (
      <Button
        variant="outline"
        className="flex items-center gap-2"
        onClick={() => navigate("/teams")}
      >
        <Users2Icon className="h-4 w-4" />
        <span>Create team</span>
      </Button>
    );
  }

  const handleTeamChange = (value: string) => {
    switchTeam?.(value);
    // Save selected team to localStorage
    localStorage.setItem("activeTeamId", value);
  };

  return (
    <div className="flex items-center gap-2">
      <Select 
        value={activeTeam?.id || ""} 
        onValueChange={handleTeamChange}
        open={isOpen}
        onOpenChange={setIsOpen}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select team" />
        </SelectTrigger>
        <SelectContent>
          {teams.map((team) => (
            <SelectItem key={team.id} value={team.id}>
              {team.name}
            </SelectItem>
          ))}
          <div className="border-t">
            <Button
              variant="ghost"
              className="w-full justify-start"
              onClick={() => {
                setIsOpen(false); // Close the select dropdown
                navigate("/teams");
              }}
              icon={<GearIcon className="h-4 w-4 mr-2" />}
            >
              Manage teams
            </Button>
          </div>
        </SelectContent>
      </Select>
    </div>
  );
}
